import { render, staticRenderFns } from "./PowerAppV4.vue?vue&type=template&id=0ecfb247"
import script from "./PowerAppV4.vue?vue&type=script&lang=js"
export * from "./PowerAppV4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports